import { render, staticRenderFns } from "./TraspasosMovimientosList.vue?vue&type=template&id=1f830ca9&"
import script from "./TraspasosMovimientosList.vue?vue&type=script&lang=js&"
export * from "./TraspasosMovimientosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports